import Box from 'UIKit/Box/Box'
import { BIG_ZERO } from 'config/constants/number'
import { USD_CURRENCY } from 'config/constants/tokens'
import useDebounceCallback from 'hooks/useDebounceCallback'
import Column from 'layout/Components/Column'
import { useEffect, useState } from 'react'
import { range } from 'utils'
import MinesSelect from 'views/InhouseGame/Mine/components/BetBoard/components/MinesSelect'
import MineGameGraphic from 'views/InhouseGame/Mine/components/GameBoard/components/MineGameGraphic'
import { MINE_GAME_SIZE, MINES_DEFAULT } from 'views/InhouseGame/Mine/config'
import { MineBlock, MineBlockResult } from 'views/InhouseGame/Mine/config/types'
import { MineProbilityFairBetInfo } from 'views/InhouseGame/config/types'
import { generateMines } from '../Utils/mineResult'

const MineVerifyForm: React.FC<{
  clientSeed: string
  serverSeed: string
  nonce: number
  initialMineBet?: MineProbilityFairBetInfo
  onVerified: (resultText: any) => void
}> = ({ onVerified, clientSeed, serverSeed, nonce, initialMineBet }) => {
  const [mines, setMines] = useState<number>(initialMineBet?.data.mines || MINES_DEFAULT)

  const debounceCallback = useDebounceCallback()

  useEffect(() => {
    debounceCallback(async () => {
      if (mines && clientSeed && serverSeed && nonce >= 0) {
        const minePositionIds = generateMines(serverSeed, clientSeed, nonce, mines)
        const defaultResult = range(0, MINE_GAME_SIZE * MINE_GAME_SIZE).map(
          () =>
            ({
              isUserOpened: true,
              value: MineBlockResult.Diamond,
            } as MineBlock),
        )

        for (let index = 0; index < minePositionIds.length; index++) {
          const element = minePositionIds[index]
          defaultResult[element] = {
            ...defaultResult[element],
            value: MineBlockResult.Mine,
          }
        }

        const bet = {
          id: null,
          betAmount: { amount: BIG_ZERO, token: USD_CURRENCY },
          mines,
          result: defaultResult,
          isCompleted: true,
        }

        onVerified(
          <Box width="100%">
            <MineGameGraphic currentBet={bet} mines={mines} viewMode />
          </Box>,
        )
      } else onVerified(null)
    }, 300)
  }, [mines, clientSeed, serverSeed, nonce])

  return (
    <Column>
      <MinesSelect mines={mines} onSelect={setMines} mb="16px" height="44px" />
    </Column>
  )
}

export default MineVerifyForm
